<template>
  <div>
    <!-- 現在位置アイコン表示 -->
    <l-marker
      v-if="showCurrentLocationIcon"
      :lat-lng="getCurrentLocation"
      :icon="currentLocation"
      :zIndexOffset="600"
      :options="options"
      @click="currentLocationClick()"
    ></l-marker>
    <!-- 登録地点アイコン表示 -->
    <div v-if="showPoint">
      <div v-for="[key, value] in Array.from(pointRegistList)" :key="key">
        <l-marker
          v-if="value.center"
          :lat-lng="value.center"
          :icon="registrationPoint.get(key)"
          :zIndexOffset="650"
          :options="options"
          @click="pointClick(key)"
        ></l-marker>
      </div>
    </div>
    <!-- 登録地点アイコン(未確定)表示 -->
    <div v-if="showEditLocation">
      <l-marker
        :lat-lng="getEditLocation"
        :icon="registrationPoint.get(getSelectedPoint)"
        :zIndexOffset="650"
        :options="options"
      ></l-marker>
    </div>
  </div>
</template>
<!-- ----------------------------------------------- -->
<script>
import { LMarker } from "vue2-leaflet";
import mixin from "../../../lib/mixin.js";
import Marker from "../../../lib/markerSetting.js";

/**
 * 川の防災情報 地図画面 地点レイヤー
 * PointLayer.vue
 * @author LIS
 */

export default {
  name: "point-layer",
  mixins: [mixin],
  components: {
    LMarker,
  },
  /** データ部 */
  data: () => ({
    currentLocation: null,
    registrationPoint: new Map(),
    // マーカーオプション(タブ遷移の抑止)
    options: {
      keyboard: false,
    },
  }),
  mounted() {
    // 現在位置アイコン設定
    this.currentLocation = Marker.getIconObj(
      "current",
      this.mapConfig.markerSetting.current.size
    );
    // 登録地点アイコン設定
    this.setRegistIconObj();
  },
  /** 算出部 */
  computed: {
    /** 地図設定情報 */
    mapConfig: {
      get() {
        return this.$store.state.map.mapConfig;
      },
    },
    /** 現在位置座標取得 */
    getCurrentLocation: {
      get() {
        return this.$store.state.map.currentLocation;
      },
    },
    /** 現在位置アイコンの表示設定（現在位置情報取得フラグ） */
    showCurrentLocationIcon: {
      get() {
        return this.$store.state.map.currentLocationFlag;
      },
    },
    /** 地点登録リスト */
    pointRegistList: {
      get() {
        return this.$store.state.map.point;
      },
    },
    /** 登録地点選択座標 */
    getEditLocation: {
      get() {
        return this.$store.state.map.editLocation.latlng;
      },
    },
    /** 地点登録時の選択地点番号 */
    getSelectedPoint: {
      get() {
        return this.$store.state.viewConfig.selectedPoint + 1;
      },
    },
    /** 登録地点アイコン表示判定 */
    showPoint: {
      get() {
        // 表示設定画面の地点登録、登録地点画面表示中は必ず表示する
        if (
          this.$store.state.app.content === "VcPoint" ||
          this.$store.state.app.content === "RegistPoint"
        ) {
          return true;
        } else if (this.$store.state.map.zoom >= this.mapConfig.zoomShowPoint) {
          // 表示ズームレベルの場合は、表示設定に従う
          return this.$store.state.map.viewPoint;
        }
        return false;
      },
    },
    /** 登録地点アイコン(未確定)表示判定 */
    showEditLocation: {
      get() {
        // 地点登録の確定前状態の場合のみ表示する
        if (
          this.getEditLocation &&
          Object.keys(this.getEditLocation).length !== 0 &&
          this.$store.state.map.editLocationMode === 2
        ) {
          return true;
        }
        return false;
      },
    },
    /** webストレージ編集日時 */
    editWebStorageDate: {
      get() {
        return this.$store.state.map.editWebStorageDate;
      },
    },
  },
  methods: {
    /** 登録地点アイコンクリック時の処理 */
    pointClick(key) {
      // 地点登録操作時は、地図移動を行わない。
      if (
        this.$store.state.map.editLocationMode === 0 &&
        this.$store.state.map.editTmMode === 0 &&
        !location.pathname.startsWith("/kawabou/rp")
      ) {
        this.$store.dispatch("map/moveMapPoint", {
          latLng: this.$store.state.map.point.get(key).center,
          flyto: true,
        });

        // 登録地点情報へ遷移
        this.$store.commit("map/setSelectPointIndex", key - 1);
        if (this.$store.state.app.mode == "pc") {
          this.routerPushPoint("/pc/rp");
        } else {
          this.routerPushPoint("/mb/rp");
        }
      }
    },
    /** 現在位置アイコンクリックで現在位置に移動 */
    currentLocationClick() {
      // 地点登録操作時は、地図移動を行わない。
      if (
        this.$store.state.map.editLocationMode === 0 &&
        this.$store.state.map.editTmMode === 0 &&
        this.$store.state.app.content !== "VcCustom"
      ) {
        this.$store.dispatch(
          "map/moveMapLocation",
          this.$store.state.map.currentLocation
        );
      }
    },
    /** 登録地点アイコン設定 */
    setRegistIconObj() {
      this.registrationPoint = new Map();

      for (let mapKey = 1; mapKey <= 5; mapKey++) {
        const mapObj = this.pointRegistList.get(mapKey);
        let iconName = "";
        let iconSize = this.mapConfig.markerSetting.registMiddle.size;
        if (mapObj) {
          iconName = mapObj.iconImg;
          if (mapObj.iconSize == 2) {
            iconSize = this.mapConfig.markerSetting.registSmall.size;
          } else if (mapObj.iconSize == 0) {
            iconSize = this.mapConfig.markerSetting.registBig.size;
          }
        }
        this.registrationPoint.set(
          mapKey,
          Marker.getRegistIconObj(iconName, iconSize)
        );
      }
    },
  },
  watch: {
    /** webストレージ編集日時 */
    editWebStorageDate() {
      // 登録地点アイコン設定
      this.setRegistIconObj();
    },
  },
};
</script>
